// extracted by mini-css-extract-plugin
export default {"coBuyer":"styles_coBuyer__YPo+T","pageTitle":"styles_pageTitle__ZUSeS"};